<template>
  <Transition name="rld">
    <div v-if="isLoading" class="rld-overlay" aria-label="Loading" role="status">
      <div class="rld-card">
        <svg viewBox="0 0 320 150" width="300" height="141" aria-hidden="true" style="display:block;overflow:visible">
          <!-- speed lines (left of car) -->
          <line x1="14" y1="78"  x2="42" y2="78"  stroke="var(--rld-road-dash)"  stroke-width="4" stroke-linecap="round" stroke-dasharray="16 22" class="rld-speed rld-speed--1" />
          <line x1="6"  y1="90"  x2="38" y2="90"  stroke="var(--rld-road-base)"  stroke-width="4" stroke-linecap="round" stroke-dasharray="12 20" class="rld-speed rld-speed--2" />
          <line x1="12" y1="102" x2="40" y2="102" stroke="var(--rld-road-dash)"  stroke-width="4" stroke-linecap="round" stroke-dasharray="10 24" opacity="0.6" class="rld-speed rld-speed--3" />

          <!-- gear (over hood) -->
          <g transform="translate(262,30)">
            <g class="rld-gear-spin">
              <rect x="-3"  y="-16" width="6" height="7" rx="1.5" fill="var(--rld-gear)" />
              <rect x="-3"  y="9"   width="6" height="7" rx="1.5" fill="var(--rld-gear)" />
              <rect x="-16" y="-3"  width="7" height="6" rx="1.5" fill="var(--rld-gear)" />
              <rect x="9"   y="-3"  width="7" height="6" rx="1.5" fill="var(--rld-gear)" />
              <rect x="-3"  y="-16" width="6" height="7" rx="1.5" fill="var(--rld-gear)" transform="rotate(45)" />
              <rect x="-3"  y="9"   width="6" height="7" rx="1.5" fill="var(--rld-gear)" transform="rotate(45)" />
              <rect x="-16" y="-3"  width="7" height="6" rx="1.5" fill="var(--rld-gear)" transform="rotate(45)" />
              <rect x="9"   y="-3"  width="7" height="6" rx="1.5" fill="var(--rld-gear)" transform="rotate(45)" />
              <circle cx="0" cy="0" r="11" fill="var(--rld-gear)" />
              <circle cx="0" cy="0" r="4.5" fill="var(--rld-card-bg)" />
            </g>
          </g>

          <!-- wrench (over hood) -->
          <g transform="translate(289,46)">
            <g class="rld-wrench-swing">
              <circle cx="0" cy="-6" r="6" fill="var(--rld-gear)" />
              <rect x="-2.5" y="-12" width="5" height="5" fill="var(--rld-card-bg)" />
              <rect x="-2"   y="-4"  width="4" height="16" rx="2" fill="var(--rld-gear)" />
            </g>
          </g>

          <!-- 4x4 vehicle (slightly scaled, sits on the road) -->
          <g transform="translate(160,134) scale(0.85) translate(-160,-134)">
            <g class="rld-car-bob">
              <!-- hard-top cab -->
              <polygon points="86,32 179,32 186,64 86,64" fill="var(--rld-accent-deep)" />
              <rect x="94"  y="38" width="38" height="20" rx="2" fill="var(--rld-glass)" />
              <rect x="140" y="38" width="28" height="20" rx="2" fill="var(--rld-glass)" />
              <polygon points="174,38 178,38 183,58 174,58" fill="var(--rld-glass)" />
              <!-- body tub + hood seam -->
              <rect x="46"  y="62" width="210" height="42" rx="6" fill="var(--rld-accent)" />
              <rect x="184" y="64" width="2.5" height="38" fill="var(--rld-accent-deep)" opacity="0.55" />
              <!-- fender flares -->
              <rect x="66"  y="82" width="46" height="9" rx="4.5" fill="var(--rld-accent-deep)" />
              <rect x="188" y="82" width="46" height="9" rx="4.5" fill="var(--rld-accent-deep)" />
              <!-- grille slats + headlight -->
              <rect x="246" y="66" width="10" height="26" rx="2" fill="var(--rld-wheel-hub)" />
              <rect x="249" y="68" width="1.8" height="22" fill="var(--rld-wheel)" opacity="0.45" />
              <rect x="252.5" y="68" width="1.8" height="22" fill="var(--rld-wheel)" opacity="0.45" />
              <circle cx="240" cy="72" r="4.5" fill="var(--rld-head)" />
              <!-- tail light + rear bumper -->
              <rect x="47"  y="66" width="6"  height="12" rx="3" fill="var(--rld-tail)" />
              <rect x="246" y="96" width="14" height="8"  rx="3" fill="var(--rld-gear)" />
              <!-- door emblem — white badge with Rafid "R" icon -->
              <rect x="141" y="66" width="26" height="26" rx="5" fill="#ffffff" />
              <image :href="LOGO" x="144.5" y="68.5" width="19" height="20.9" />

              <!-- rear chunky wheel -->
              <g transform="translate(90,106)">
                <circle cx="0" cy="0" r="19" fill="var(--rld-wheel)" />
                <circle cx="0" cy="0" r="19" fill="none" stroke="var(--rld-wheel)" stroke-width="4" stroke-dasharray="4 4" />
                <g class="rld-wheel-spin">
                  <line x1="-12" y1="0"     x2="12"  y2="0"    stroke="var(--rld-wheel-hub)" stroke-width="2.5" />
                  <line x1="-6"  y1="-10.4" x2="6"   y2="10.4" stroke="var(--rld-wheel-hub)" stroke-width="2.5" />
                  <line x1="-6"  y1="10.4"  x2="6"   y2="-10.4" stroke="var(--rld-wheel-hub)" stroke-width="2.5" />
                </g>
                <circle cx="0" cy="0" r="5" fill="var(--rld-wheel-hub)" />
              </g>

              <!-- front chunky wheel -->
              <g transform="translate(211,106)">
                <circle cx="0" cy="0" r="19" fill="var(--rld-wheel)" />
                <circle cx="0" cy="0" r="19" fill="none" stroke="var(--rld-wheel)" stroke-width="4" stroke-dasharray="4 4" />
                <g class="rld-wheel-spin">
                  <line x1="-12" y1="0"     x2="12"  y2="0"    stroke="var(--rld-wheel-hub)" stroke-width="2.5" />
                  <line x1="-6"  y1="-10.4" x2="6"   y2="10.4" stroke="var(--rld-wheel-hub)" stroke-width="2.5" />
                  <line x1="-6"  y1="10.4"  x2="6"   y2="-10.4" stroke="var(--rld-wheel-hub)" stroke-width="2.5" />
                </g>
                <circle cx="0" cy="0" r="5" fill="var(--rld-wheel-hub)" />
              </g>
            </g>
          </g>

          <!-- road -->
          <line x1="18" y1="134" x2="302" y2="134" stroke="var(--rld-road-base)" stroke-width="5" stroke-linecap="round" />
          <line x1="18" y1="134" x2="302" y2="134" stroke="var(--rld-road-dash)" stroke-width="5" stroke-linecap="round" stroke-dasharray="26 18" class="rld-road-move" />
        </svg>

        <!-- pulsing dots -->
        <div class="rld-dots">
          <span class="rld-dot" style="animation-delay:0s" />
          <span class="rld-dot" style="animation-delay:0.2s" />
          <span class="rld-dot" style="animation-delay:0.4s" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useRequestLoader } from "../composables/useRequestLoader";
const { isLoading } = useRequestLoader();

// Rafid "R" icon embedded as data URI — no external fetch needed inside the SVG.
const LOGO = "data:image/png;base64,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";
</script>

<style scoped>
/* ── CSS custom properties — light mode ─────────────────────────────── */
.rld-overlay {
  --rld-overlay-bg:  #7b828d;
  --rld-card-bg:     #ffffff;
  --rld-card-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
  --rld-accent:      #17b3cf;
  --rld-accent-deep: #0e93ad;
  --rld-glass:       #9ee7f2;
  --rld-wheel:       #37404d;
  --rld-wheel-hub:   #c8d0da;
  --rld-road-base:   #e3e7ec;
  --rld-road-dash:   #55c9de;
  --rld-gear:        #aab4c0;
  --rld-tail:        #ef5350;
  --rld-head:        #ffc93c;
  --rld-dur:         0.9s;
}

/* dark mode — html[data-theme="dark"] set by useTheme() */
[data-theme="dark"] .rld-overlay {
  --rld-overlay-bg:  #10151d;
  --rld-card-bg:     #1c232e;
  --rld-card-shadow: 0 24px 60px rgba(0, 0, 0, 0.6);
  --rld-accent:      #22c3de;
  --rld-accent-deep: #128ba3;
  --rld-glass:       #7adaea;
  --rld-wheel:       #0c1016;
  --rld-wheel-hub:   #55606e;
  --rld-road-base:   #2a3340;
  --rld-road-dash:   #2fb9d3;
  --rld-gear:        #4d5866;
}

/* ── Overlay ─────────────────────────────────────────────────────────── */
.rld-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: var(--rld-overlay-bg);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Card ────────────────────────────────────────────────────────────── */
.rld-card {
  background: var(--rld-card-bg);
  border-radius: 24px;
  box-shadow: var(--rld-card-shadow);
  padding: 36px 44px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 340px;
  max-width: calc(100vw - 32px);
}

/* ── SVG animation classes ───────────────────────────────────────────── */
.rld-wheel-spin {
  transform-box: fill-box;
  transform-origin: center;
  animation: rld-wheel-spin var(--rld-dur) linear infinite;
}
.rld-gear-spin {
  transform-box: fill-box;
  transform-origin: center;
  animation: rld-gear-spin calc(var(--rld-dur) * 2) linear infinite;
}
.rld-wrench-swing {
  transform-origin: 0px -6px;
  animation: rld-wrench-swing calc(var(--rld-dur) * 1.2) ease-in-out infinite;
}
.rld-car-bob {
  animation: rld-car-bob var(--rld-dur) ease-in-out infinite;
}
.rld-speed--1 { animation: rld-road-move calc(var(--rld-dur) * 0.70) linear infinite; }
.rld-speed--2 { animation: rld-road-move calc(var(--rld-dur) * 0.55) linear infinite; }
.rld-speed--3 { animation: rld-road-move calc(var(--rld-dur) * 0.85) linear infinite; }
.rld-road-move { animation: rld-road-move var(--rld-dur) linear infinite; }

/* ── Pulsing dots ────────────────────────────────────────────────────── */
.rld-dots {
  display: flex;
  gap: 6px;
  align-items: center;
}
.rld-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--rld-accent);
  animation: rld-dot-pulse 1.2s ease-in-out infinite;
}

/* ── Keyframes ───────────────────────────────────────────────────────── */
@keyframes rld-wheel-spin  { to   { transform: rotate(360deg); } }
@keyframes rld-gear-spin   { to   { transform: rotate(360deg); } }
@keyframes rld-road-move   { to   { stroke-dashoffset: -44; } }
@keyframes rld-wrench-swing {
  0%, 100% { transform: rotate(-24deg); }
  50%      { transform: rotate(24deg); }
}
@keyframes rld-car-bob {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-2.5px); }
}
@keyframes rld-dot-pulse {
  0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
  40%           { opacity: 1;    transform: translateY(-3px); }
}

/* ── Transition ──────────────────────────────────────────────────────── */
.rld-enter-active { transition: opacity 0.1s ease; }
.rld-leave-active { transition: opacity 0.3s ease; }
.rld-enter-from,
.rld-leave-to     { opacity: 0; }
</style>
